import React, { Component, createRef } from 'react';

class TripNavigationBar extends Component {
    constructor(props) {
        super(props);
        this.scrollRef = createRef();
        this.isDragging = false;
        this.startX = 0;
        this.scrollLeft = 0;
        this.lastX = 0;
        this.velocity = 0;
        this.frame = null;
    }

    componentDidMount() {
        const el = this.scrollRef.current;

        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;

        const onMouseDown = (e) => {
            isDragging = true;
            el.classList.add('dragging');
            startX = e.pageX;
            scrollLeft = el.scrollLeft;
            el.style.cursor = 'grabbing';
            el.style.userSelect = 'none';

            // Attach global listeners
            window.addEventListener('mousemove', onMouseMove);
            window.addEventListener('mouseup', onMouseUp);
        };

        const onMouseMove = (e) => {
            if (!isDragging) return;
            const x = e.pageX;
            const walk = x - startX;
            el.scrollLeft = scrollLeft - walk;
        };

        const onMouseUp = () => {
            if (!isDragging) return;
            isDragging = false;
            el.classList.remove('dragging');
            el.style.cursor = 'grab';
            el.style.userSelect = '';

            // Remove global listeners
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };

        el.addEventListener('mousedown', onMouseDown);

        // Save for cleanup
        this._handlers = { onMouseDown };
        this._globalHandlers = { onMouseMove, onMouseUp };
    }


    componentWillUnmount() {
        const el = this.scrollRef.current;
        const { onMouseDown } = this._handlers;
        const { onMouseMove, onMouseUp } = this._globalHandlers;

        el.removeEventListener('mousedown', onMouseDown);
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
    }


    cutString(str, max_length=20) {
        const maxLength = max_length;

        if (str.length <= maxLength) {
            return str;
        }
        const firstSpaceAfter20 = str.indexOf(' ', maxLength);
        if (firstSpaceAfter20 !== -1) {
            // Optionally add an ellipsis "..." to indicate truncation
            return str.slice(0, firstSpaceAfter20);
        }
        return str.slice(0, maxLength);
    }


    render() {
        return (
            <div className="trip__navigationbar" ref={this.scrollRef}>
                {this.props.segments.map((segment, index) => (
                    <div key={index} onClick={() => this.props.scrollToSection(segment.order)} className={"trip__navigationbar__button" + (this.props.active_index == segment.order ? " trip__navigationbar__button--active" : "")}>
                        {this.cutString(segment.title, 12)}
                    </div>
                ))}
            </div>
        );
    }
}

export default TripNavigationBar;
